import { createSlice } from "@reduxjs/toolkit";
import { 
  getReminderFlow, 
  createReminderFlow, 
  updateReminderFlow, 
  deleteReminderFlow,
  clearLocalActiveReminderFlow 
} from "./actions";

export const initialState = {
  reminderFlow: { 
    id: '', 
    before_in: '', 
    send_at: '', 
    text_translations: null,
    time_zone: '', 
    updated_at: '' 
  },
  loading: false
};

const slice = createSlice({
  name: 'reminderFlows',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getReminderFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(getReminderFlow.fulfilled, (state, action) => {
        const { reminder_flow } = action.payload;
        const reminderFlow = { ...state.reminderFlow, ...reminder_flow };

        state.loading = false;
        state.reminderFlow = reminderFlow;
      })
      .addCase(getReminderFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(createReminderFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(createReminderFlow.fulfilled, (state, action) => {
        const { reminder_flow } = action.payload;

        state.loading = false;
        state.reminderFlow = reminder_flow;       
      })
      .addCase(createReminderFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateReminderFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateReminderFlow.fulfilled, (state, action) => {
        const { status, reminder_flow } = action.payload;
        const updatedReminderFlow = { ...state.reminderFlow, ...reminder_flow };

        state.loading = false;
        if (status === 204) state.reminderFlow = updatedReminderFlow;       
      })
      .addCase(updateReminderFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteReminderFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteReminderFlow.fulfilled, (state, action) => {
        const { status } = action.payload;

        state.loading = false;
        if (status === 204) state.reminderFlow = initialState.reminderFlow;       
      })
      .addCase(deleteReminderFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(clearLocalActiveReminderFlow, state => {
        state.reminderFlow = initialState.reminderFlow;
      })
  }
})

export default slice.reducer;